import React from 'react'
import { LiveLink } from '~/components/LiveLink'
import { formatDateTime } from '~/utils/date'

export function MeetingTitle({ title, href }: { title: string; href?: string }) {
  return (
    <LiveLink className="text-base line-clamp-3" href={href}>
      {title}
    </LiveLink>
  )
}

export function RecordingDateTime({ startedAtUnixMs }: { startedAtUnixMs?: number }) {
  return startedAtUnixMs ? <div className="text-secondary">{formatDateTime(startedAtUnixMs)}</div> : <>&nbsp;</>
}
